// extracted by mini-css-extract-plugin
module.exports = {"offerDesktop":"ProductDetail_offerDesktop__APFk2","offerMobile":"ProductDetail_offerMobile__VXNov","textBrand":"ProductDetail_textBrand__IRQMn"};